// extracted by mini-css-extract-plugin
export default {"container":"Svgs_container__qIvCa"};